import { AModel } from '../models/resources/a-model';
import { effect, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AResourceService } from '../services/resources/a-resource.service';

export abstract class AConcreteResource<M extends AModel> {
  model = signal<M | null>(null);
  modelId: number;

  protected constructor(
    protected router: Router,
    protected resourceService: AResourceService<M>,
    protected isConcreteSubPage: boolean = false,
  ) {
    const currentUrl = this.router.url; // Get the current URL
    const urlSegments = currentUrl.split('/'); // Split the URL by '/'
    this.modelId = +urlSegments[isConcreteSubPage ? urlSegments.length - 2 : urlSegments.length - 1]; // Get the last segment


    effect(() => {
      const currentConcreteModel = this.resourceService.currentConcreteModel();
      const foundModel = this.resourceService
        .models()
        .find((o) => o.id === this.modelId);

      // Update the model signal only if the value has changed
      if (currentConcreteModel != null && this.model() !== currentConcreteModel) {
        this.model.set(currentConcreteModel);
      } else if (foundModel != null && this.model() !== foundModel) {
        this.model.set(foundModel);
        this.resourceService.addConcreteModel(foundModel);
      }
    });
  }
}
